'use strict';

(function () {
  if (!customElements.get('slideshow-banner')) {
    const BREAKPOINTS = {
      sm: 750,
      lg: 990,
    };

    class SlideshowBanner extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.pagination = this.querySelector('.swiper-pagination');
        this.pauseBtn = this.querySelector('.swiper-button-pause');

        this.initSwiper();
        this.initPauseButton();
      }

      initSwiper = () => {
        const slides = this.querySelectorAll('.swiper-slide');
        const slidesLength = slides.length;
        let {
          slidesPerView = 1,
          slidesPerViewSm,
          slidesPerViewLg,
          effect,
          speed,
          autoplay,
          loop = 'false',
          spaceBetween,
          spaceBetweenPc,
        } = this.dataset;
        if (!slidesPerViewSm) slidesPerViewSm = slidesPerView;
        if (!slidesPerViewLg) slidesPerViewLg = slidesPerView;

        slidesPerView = slidesLength < +slidesPerView ? slidesLength : +slidesPerView;
        slidesPerViewSm = slidesLength < +slidesPerViewSm ? slidesLength : +slidesPerViewSm;
        slidesPerViewLg = slidesLength < +slidesPerViewLg ? slidesLength : +slidesPerViewLg;

        speed = speed * 1000;

        if (autoplay == 'true') {
          autoplay = {
            delay: speed,
            disableOnInteraction: false,
          };
        } else {
          autoplay = false;
        }

        let pagination = false;

        loop = loop == 'false' ? false : true;

        if (this.pagination) {
          pagination = {
            el: '.swiper-pagination',
            clickable: true,
          };
        }

        const swiperParams = {
          autoplay,
          slidesPerView,
          pagination,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          grabCursor: true,
          effect,
          centeredSlides: true,
          loop: loop,
          spaceBetween,
          breakpoints: {
            [BREAKPOINTS.sm]: {
              slidesPerView: slidesPerViewSm,
              spaceBetween: spaceBetweenPc,
            },
            [BREAKPOINTS.lg]: {
              slidesPerView: slidesPerViewLg,
              spaceBetween: spaceBetweenPc,
            },
          },
        };

        this.swiper = new Swiper(this, swiperParams);
      };

      // initPauseButton = () => {
      //   if (!this.pauseBtn) return;

      //   // Hide pause button entirely if autoplay is not enabled
      //   if (!this.swiper.autoplay.running) {
      //     this.pauseBtn.style.display = 'none';
      //     return;
      //   }

      //   this.pauseBtn.addEventListener('click', () => {
      //     const isPaused = this.pauseBtn.getAttribute('aria-pressed') === 'true';

      //     if (isPaused) {
      //       this.swiper.autoplay.start();
      //       this.pauseBtn.setAttribute('aria-pressed', 'false');
      //     } else {
      //       this.swiper.autoplay.stop();
      //       this.pauseBtn.setAttribute('aria-pressed', 'true');
      //     }

      //     this.pauseBtn.querySelector('.swiper-button-pause__pause-icon').style.display = isPaused ? '' : 'none';
      //     this.pauseBtn.querySelector('.swiper-button-pause__play-icon').style.display = isPaused ? 'none' : '';
      //   });
      // };
      initPauseButton = () => {
  if (!this.pauseBtn) return;

  this.pauseBtn.addEventListener('click', () => {
    const isPaused = this.pauseBtn.getAttribute('aria-pressed') === 'true';

    if (isPaused) {
      this.swiper.autoplay.start();
      this.pauseBtn.setAttribute('aria-pressed', 'false');
    } else {
      this.swiper.autoplay.stop();
      this.pauseBtn.setAttribute('aria-pressed', 'true');
    }

    this.pauseBtn.querySelector('.swiper-button-pause__pause-icon').style.display = isPaused ? '' : 'none';
    this.pauseBtn.querySelector('.swiper-button-pause__play-icon').style.display = isPaused ? 'none' : '';
  });

  // If autoplay is off by default, show play icon initially
  if (!this.swiper.autoplay.running) {
    this.pauseBtn.setAttribute('aria-pressed', 'true');
    this.pauseBtn.querySelector('.swiper-button-pause__pause-icon').style.display = 'none';
    this.pauseBtn.querySelector('.swiper-button-pause__play-icon').style.display = '';
  }
};
    }

    customElements.define('slideshow-banner', SlideshowBanner);
  }
})();